<template>
  <v-container
    id="templateSummaries"
    class="pa-0"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
      class="oe-summary-section"
    />
    <div
      v-if="!loading && (!templates || !templates.length)"
      class="oe-summary-section"
    >
      <v-alert
        type="info"
      >
        No template details found
      </v-alert>
    </div>
    <div
      v-if="!loading && templates && templates.length"
      :key="displayChangeKey"
    >
      <div
        v-for="(template, templateKey) in templates"
        :key="templateKey"
        class="oe-summary-section page-break-before"
      >
        <template-summary-details
          :expanded="displaySection"
          :open-enrollment="openEnrollment"
          :template="template"
          :print="print"
          @approval:changed="$emit('approval:changed')"
        />
      </div>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'TemplateSummaries',

    components: {
      TemplateSummaryDetails: () => import('./TemplateSummaryDetails'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      loadingAnswers: false,
      templates: null,

      errorMessage: null,
      displayError: false,
      formErrors: {},
      displaySection: false,
      displayChangeKey: 0,

      answersResource: new TroodyApi('oeTemplateAnswer/'),
    }),

    computed: {
      loading () {
        return (this.loadingAnswers)
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
        this.displayChangeKey++
        this.addDisplayProperty(this.displaySection)
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadAnswers()
        this.displaySection = this.expanded
      },

      addDisplayProperty (val) {
        if (this.templates && this.templates.length) {
          this.templates.forEach((template) => {
            if (template) {
              template.displaySection = val
            }
          })
          this.$forceUpdate()
        }
      },

      loadAnswers () {
        this.loadingAnswers = true
        this.answersResource.getFrom('structured/', this.openEnrollment.id)
          .then(data => {
            this.loadingAnswers = false
            this.templates = data
            this.addDisplayProperty(this.displaySection)
          })
          .catch((error) => {
            this.loadingAnswers = false
            this.templates = null
            this.showError(error, 'Failed to load answers!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
